export const HEADER_LINKS = [
  {
    title: "About",
    route: "about",
  },
  {
    title: "Our Team",
    route: "out_team",
  },
  {
    title: "Analysis",
    route: "analysis",
  },
  {
    title: "Algorithms",
    route: "algorithms",
  },
  {
    title: "Education",
    route: "",
    redirect: process.env.REACT_APP_API_URL_BLOG,
  },
];
